import React from "react";
import { Link } from "react-router-dom";
import Moment from "react-moment";

const MentorNotificationItem = ({
  notification,
  deleteNotification,
  setnotificationsOpen,
}) => {
  return (
    <div className={notification.unread ? "notification red" : "notification"}>
      {notification.type === "giftedcourse" && (
        <div className="single-notification">
          <Link
            to={`/${notification.channelid}`}
            onClick={() => setnotificationsOpen(false)}
          >
            <div className="notif-avi-container">
              <img
                src={`https://ime.sfo3.cdn.digitaloceanspaces.com/public/uploads/avatars/${notification.avatar}`}
                className="notif-avi"
              />
            </div>
          </Link>
          <div className="notification-text red">
            <div className="notification-type">
              <i className="fas fa-gift mx-5 red"></i>
              Gifted Course
            </div>
            <div className="notification-text-title">
              Lorem ipsum dolor sit amet consectetur, adipisicing elit. or ime
              monthly courses.
            </div>
            <div className="notification-user red">
              Gifted from {notification.firstname} {notification.lastname}
            </div>
            <div className="notification-date">
              <i className="far fa-clock mx-5 red"></i>
              <Moment format="MM/DD/YYYY">{notification.date}</Moment>
            </div>
          </div>
          <div
            onClick={() => deleteNotification(notification._id)}
            className="remove-notification"
          >
            <i className="fas fa-times red"></i>
          </div>
        </div>
      )}
      {notification.type === "giftedsubscription" && (
        <div className="single-notification">
          <Link
            to={`/${notification.channelid}`}
            onClick={() => setnotificationsOpen(false)}
          >
            <div className="notif-avi-container">
              <img
                src={`https://ime.sfo3.cdn.digitaloceanspaces.com/public/uploads/avatars/${notification.avatar}`}
                className="notif-avi"
              />
            </div>
          </Link>
          <div className="notification-text red">
            <div className="notification-type">
              <i className="fas fa-gift mx-5 red"></i>
              Gifted Subscription
            </div>
            <div className="notification-text-title">
              One month subscription to Mentor Name or ime subscription
            </div>
            <div className="notification-user red">
              Gifted from {notification.firstname} {notification.lastname}
            </div>
            <div className="notification-date">
              <i className="far fa-clock mx-5 red"></i>
              <Moment format="MM/DD/YYYY">{notification.date}</Moment>
            </div>
          </div>
          <div
            onClick={() => deleteNotification(notification._id)}
            className="remove-notification"
          >
            <i className="fas fa-times red"></i>
          </div>
        </div>
      )}
      {notification.type === "acceptedcasualrequest" && (
        <div className="single-notification">
          <Link
            to={`/${notification.channelid}`}
            onClick={() => setnotificationsOpen(false)}
          >
            <div className="notif-avi-container">
              <img
                src={`https://ime.sfo3.cdn.digitaloceanspaces.com/public/uploads/avatars/${notification.avatar}`}
                className="notif-avi"
              />
            </div>
          </Link>
          <div className="notification-text red">
            <div className="notification-type">
              <i className="fas fa-user-friends mx-5 red"></i>
              Accepted Friend Request
            </div>
            <div className="notification-text-title">
              <span className="red bold">
                {notification.firstname} {notification.lastname}
              </span>{" "}
              added you as a <span className="red bold">Casual</span> Friend.
            </div>
            <div className="notification-date">
              <i className="far fa-clock mx-5 red"></i>
              <Moment format="MM/DD/YYYY">{notification.date}</Moment>
            </div>
          </div>
          <div
            onClick={() => deleteNotification(notification._id)}
            className="remove-notification"
          >
            <i className="fas fa-times red"></i>
          </div>
        </div>
      )}
      {notification.type === "friends" && (
        <div className="single-notification">
          <Link
            to={`/${notification.channelid}`}
            onClick={() => setnotificationsOpen(false)}
          >
            <div className="notif-avi-container">
              <img
                src={`https://ime.sfo3.cdn.digitaloceanspaces.com/public/uploads/avatars/${notification.avatar}`}
                className="notif-avi"
              />
            </div>
          </Link>
          <div className="notification-text red">
            <div className="notification-type">
              <i className="fas fa-user-friends mx-5 red"></i>
              Received Friend Request
            </div>
            <div className="notification-text-title">
              <span className="red bold">
                {notification.firstname} {notification.lastname}
              </span>{" "}
              sent you a Friend request.
            </div>
            <div className="notification-date">
              <i className="far fa-clock mx-5 red"></i>
              <Moment format="MM/DD/YYYY">{notification.date}</Moment>
            </div>
          </div>
          <div
            onClick={() => deleteNotification(notification._id)}
            className="remove-notification"
          >
            <i className="fas fa-times red"></i>
          </div>
        </div>
      )}
      {notification.type === "approvedmentor" && (
        <div className="single-notification">
          <Link
            to={`/${notification.channelid}`}
            onClick={() => setnotificationsOpen(false)}
          >
            <div className="notif-avi-container">
              <img
                src={`https://ime.sfo3.cdn.digitaloceanspaces.com/public/uploads/avatars/${notification.avatar}`}
                className="notif-avi"
              />
            </div>
          </Link>
          <div className="notification-text red">
            <div className="notification-type">
              <i className="fas fa-file-signature mx-5 red"></i>
              Received Approval Request
            </div>
            <div className="notification-text-title">
              <span className="red bold">
                {notification.firstname} {notification.lastname}
              </span>{" "}
              sent you an <span className="red bold">Approval</span> request.
            </div>
            <div className="notification-date">
              <i className="far fa-clock mx-5 red"></i>
              <Moment format="MM/DD/YYYY">{notification.date}</Moment>
            </div>
          </div>
          <div
            onClick={() => deleteNotification(notification._id)}
            className="remove-notification"
          >
            <i className="fas fa-times red"></i>
          </div>
        </div>
      )}
      {notification.type === "expiringmentorsubscription" && (
        <div className="single-notification">
          <Link
            to={`/${notification.channelid}`}
            onClick={() => setnotificationsOpen(false)}
          >
            <div className="notif-avi-container">
              <img
                src={`https://ime.sfo3.cdn.digitaloceanspaces.com/public/uploads/avatars/${notification.avatar}`}
                className="notif-avi"
              />
            </div>
          </Link>
          <div className="notification-text red">
            <div className="notification-type">
              <i className="fas fa-user-check mx-5 red"></i>
              Expiring Subscription
            </div>
            <div className="notification-text-title">
              Your subscription to Mentor Name expires in number days.
              <span className="red cursor mx-5 bold">Resubscribe</span>?
            </div>
            <div className="notification-date">
              <i className="far fa-clock mx-5 red"></i>
              Date
            </div>
          </div>
          <div
            onClick={() => deleteNotification(notification._id)}
            className="remove-notification"
          >
            <i className="fas fa-times red"></i>
          </div>
        </div>
      )}
      {notification.type === "discussioninvite" && (
        <div className="single-notification">
          <Link
            to={`/${notification.channelid}`}
            onClick={() => setnotificationsOpen(false)}
          >
            <div className="notif-avi-container">
              <img
                src={`https://ime.sfo3.cdn.digitaloceanspaces.com/public/uploads/avatars/${notification.avatar}`}
                className="notif-avi"
              />
            </div>
          </Link>
          <div className="notification-text red">
            <div className="notification-type">
              <i className="fas fa-video mx-5 red"></i>
              Live Discussion
            </div>
            <div className="notification-text-title">
              User's name invited you to a live discussion
              <span className="red cursor mx-5 bold">Watch Now</span>
            </div>
            <div className="notification-date">
              <i className="far fa-clock mx-5 red"></i>
              Date
            </div>
          </div>
          <div
            onClick={() => deleteNotification(notification._id)}
            className="remove-notification"
          >
            <i className="fas fa-times red"></i>
          </div>
        </div>
      )}
      {notification.type === "livestream" && (
        <div className="single-notification">
          <Link
            to={`/${notification.channelid}`}
            onClick={() => setnotificationsOpen(false)}
          >
            <div className="notif-avi-container">
              <img
                src={`https://ime.sfo3.cdn.digitaloceanspaces.com/public/uploads/avatars/${notification.avatar}`}
                className="notif-avi"
              />
            </div>
          </Link>
          <div className="notification-text red">
            <div className="notification-type">
              <i className="fas fa-video mx-5 red"></i>
              Live Stream
            </div>
            <div className="notification-text-title">
              User name just went live!
              <span className="red cursor mx-5 bold">Watch Now</span>
            </div>
            <div className="notification-date">
              <i className="far fa-clock mx-5 red"></i>
              Date
            </div>
          </div>
          <div
            onClick={() => deleteNotification(notification._id)}
            className="remove-notification"
          >
            <i className="fas fa-times red"></i>
          </div>
        </div>
      )}
      {notification.type === "sharedarticle" && (
        <div className="single-notification">
          <Link
            to={`/${notification.channelid}`}
            onClick={() => setnotificationsOpen(false)}
          >
            <div className="notif-avi-container">
              <img
                src={`https://ime.sfo3.cdn.digitaloceanspaces.com/public/uploads/avatars/${notification.avatar}`}
                className="notif-avi"
              />
            </div>
          </Link>
          <div className="notification-text red">
            <div className="notification-type">
              <i className="far fa-newspaper mx-5 red"></i>
              Shared Article
            </div>
            <div className="notification-text-title">
              User's name shared Innovator's article with you.
              <span className="red cursor mx-5 bold">View Now</span>
            </div>
            <div className="notification-date">
              <i className="far fa-clock mx-5 red"></i>
              Date
            </div>
          </div>
          <div
            onClick={() => deleteNotification(notification._id)}
            className="remove-notification"
          >
            <i className="fas fa-times red"></i>
          </div>
        </div>
      )}
      {notification.type === "subscriber" && (
        <div className="single-notification">
          <Link
            to={`/${notification.channelid}`}
            onClick={() => setnotificationsOpen(false)}
          >
            <div className="notif-avi-container">
              <img
                src={`https://ime.sfo3.cdn.digitaloceanspaces.com/public/uploads/avatars/${notification.avatar}`}
                className="notif-avi"
              />
            </div>
          </Link>
          <div className="notification-text red">
            <div className="notification-type">
              <i className="fas fa-user-check mx-5 red bold"></i>
              New Subscriber
            </div>
            <div className="notification-text-title">
              User's name just subscribed to you!
            </div>
            <div className="notification-date">
              <i className="far fa-clock mx-5 red"></i>
              Date
            </div>
          </div>
          <div
            onClick={() => deleteNotification(notification._id)}
            className="remove-notification"
          >
            <i className="fas fa-times red"></i>
          </div>
        </div>
      )}
      {notification.type === "purchasedcourse" && (
        <div className="single-notification">
          <Link
            to={`/${notification.channelid}`}
            onClick={() => setnotificationsOpen(false)}
          >
            <div className="notif-avi-container">
              <img
                src={`https://ime.sfo3.cdn.digitaloceanspaces.com/public/uploads/avatars/${notification.avatar}`}
                className="notif-avi"
              />
            </div>
          </Link>
          <div className="notification-text red">
            <div className="notification-type">
              <i className="fas fa-graduation-cap mx-5 red"></i>
              New Course Purchase
            </div>
            <div className="notification-text-title">
              User's name just purchased your course
              <span className="red mx-5 bold">Course Name</span>
            </div>
            <div className="notification-date">
              <i className="far fa-clock mx-5 red"></i>
              Date
            </div>
          </div>
          <div
            onClick={() => deleteNotification(notification._id)}
            className="remove-notification"
          >
            <i className="fas fa-times red"></i>
          </div>
        </div>
      )}
      {notification.type === "expiringmentorsubscription" && (
        <div className="single-notification">
          <Link
            to={`/${notification.channelid}`}
            onClick={() => setnotificationsOpen(false)}
          >
            <div className="notif-avi-container">
              <img
                src={`https://ime.sfo3.cdn.digitaloceanspaces.com/public/uploads/avatars/${notification.avatar}`}
                className="notif-avi"
              />
            </div>
          </Link>
          <div className="notification-text red">
            <div className="notification-type">
              <i className="fas fa-user-check mx-5 red"></i>
              Expiring Subscription
            </div>
            <div className="notification-text-title">
              Your subscription to Mentor Name expires in number days.
              <span className="red cursor mx-5">Resubscribe</span>?
            </div>
            <div className="notification-date">
              <i className="far fa-clock mx-5 red"></i>
              <Moment format="MM/DD/YYYY">{notification.date}</Moment>
            </div>
          </div>
          <div
            onClick={() => deleteNotification(notification._id)}
            className="remove-notification"
          >
            <i className="fas fa-times red"></i>
          </div>
        </div>
      )}
      {notification.type === "follower" && (
        <div className="single-notification">
          <Link
            to={`/${notification.channelid}`}
            onClick={() => setnotificationsOpen(false)}
          >
            <div className="notif-avi-container">
              <img
                src={`https://ime.sfo3.cdn.digitaloceanspaces.com/public/uploads/avatars/${notification.avatar}`}
                className="notif-avi"
              />
            </div>
          </Link>
          <div className="notification-text red">
            <div className="notification-type">
              <i className="fas fa-users mx-5 red"></i>
              New Follower
            </div>
            <div className="notification-text-title">
              <span className="red bold">
                {notification.firstname} {notification.lastname}
              </span>{" "}
              followed you.
            </div>
            <div className="notification-date">
              <i className="far fa-clock mx-5 red"></i>
              <Moment format="MM/DD/YYYY">{notification.date}</Moment>
            </div>
          </div>
          <div
            onClick={() => deleteNotification(notification._id)}
            className="remove-notification"
          >
            <i className="fas fa-times red"></i>
          </div>
        </div>
      )}
    </div>
  );
};

export default MentorNotificationItem;
